import { combineReducers } from 'redux-immutable';
import { createResponsiveStateReducer } from 'redux-responsive';

// global store
import feedback from 'src/store/feedback/slices';
import client from 'src/store/client/reducers';
import logo from 'src/store/logo/reducers';
import menu from 'src/store/menu/slice';
import enqueue from 'src/store/enqueue/reducers';
import headerWidget from 'src/store/headerWidget/reducers';
import wishlist from 'src/store/wishlist/slice';
import bannerAppData from 'src/store/appBanners/slice';
import headerBanner from 'src/store/headerBanner/slice';
import hotelImages from 'src/store/hotelImages/slice';

import filters from './filters';
import sorting from './sorting';
import mobile from './mobile';
import view from './view';
import viewedHotels from './viewedHotels';
import searchStatus from '../searchStatus/slice';
import emptySearch from '../store/emptySearch/slices';
import map from '../store/map/slice';
import priceSubscription from '../store/priceSubscription/slice';
import emptyFiltration from '../store/emptyFiltration/slices';
import priceChart from '../store/priceChart/slice';
import hotels from '../store/hotels/slice';
import previousFilters from '../../../store/previousFilters/slice';
import travelRequirements from '../store/travelRequirements/slice';

const rootReducer = combineReducers({
  feedback,
  client,
  logo,
  menu,
  enqueue,
  headerWidget,
  headerBanner,
  wishlist,
  //
  hotels,
  filters,
  previousFilters,
  sorting,
  map,
  priceSubscription,
  mobile,
  view,
  viewedHotels,
  searchStatus,
  browser: createResponsiveStateReducer({
    small: 694,
    medium: 960,
    large: 1270,
    extraLarge: 1600,
  }),
  hotelImages,
  emptySearch,
  emptyFiltration,
  priceChart,
  bannerAppData,
  travelRequirements,
});

export default rootReducer;
